import React from 'react';
import cx from 'classnames';

import { DateParams } from 'utils/filterUtils';
import { TimesheetStatusEnum } from 'api/backofficeApiClient';
import { TimesheetStatusReportFilterTypes } from '../filters/enums';
import MemberFilter from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/filters/MemberFilter';
import ApprovalStateFilter from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/filters/ApprovalStateFilter';
import WorkerFilter from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/filters/WorkerFilter';
import DateFilter from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/filters/DateFilter';
import CustomerFilter from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/filters/CustomerFilter';

import styles from '../TimesheetStatusReportDetailsPage.module.less';

export interface TimesheetStatusReportFilters {
  [TimesheetStatusReportFilterTypes.Date]: DateParams | undefined;
  [TimesheetStatusReportFilterTypes.Worker]: string[];
  [TimesheetStatusReportFilterTypes.Customer]: string[];
  [TimesheetStatusReportFilterTypes.Member]: string[];
  [TimesheetStatusReportFilterTypes.ApprovalState]: TimesheetStatusEnum[];
}

type Props = {
  isAdmin?: boolean;
  isCorporateTA?: boolean;
  filters: TimesheetStatusReportFilters;
  onChange: (
    data: TimesheetStatusReportFilters,
    type?: TimesheetStatusReportFilterTypes,
  ) => void;
};

export default function TimesheetStatusReportFilter(props: Props) {
  const { filters, onChange, isCorporateTA, isAdmin } = props;

  return (
    <>
      <div className={cx(styles.dateBox, styles.selectBox)}>
        <DateFilter filters={filters} onChange={onChange} />
      </div>

      <div className={styles.selectBox}>
        <WorkerFilter isAdmin={isAdmin} filters={filters} onChange={onChange} />
      </div>

      {!isCorporateTA && (
        <div className={styles.selectBox}>
          <CustomerFilter
            isAdmin={isAdmin}
            filters={filters}
            onChange={onChange}
          />
        </div>
      )}

      <div className={styles.selectBox}>
        <ApprovalStateFilter filters={filters} onChange={onChange} />
      </div>

      {isAdmin && (
        <div className={styles.selectBox}>
          <MemberFilter filters={filters} onChange={onChange} />
        </div>
      )}
    </>
  );
}
